import axios from "axios";
import { showMessage, goTo } from "./NotificationService";
import queryString from "query-string";
import { de } from "date-fns/locale";

let pendingCalls = 0;

const instance = axios.create({
  withCredentials: true,
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  timeout: 0,
  headers: {
    "Content-Type": "application/json" || "array"
  },
  paramsSerializer: params =>
    queryString.stringify(params, { arrayFormat: "none" }),
  responseType: "json",
  validateStatus: function (status) {
    return status === 409 || status < 400;
  }
});

instance.interceptors.request.use(conf => {
  if (
    !conf.url.includes("medi/reportes/reportes-configurables/") &&
    !conf.url.includes("cost/actions/transferir/status/") &&
    !conf.url.includes("cost/report/") &&
    !conf.url.includes("cost/estado-transferencia-puntos/") &&
    window.location.pathname !== "/blank" &&
    !conf.inBackground
  ) {
    pendingCalls++;
    showMessage("ajax-start", null);
  }
  return conf;
});

instance.interceptors.response.use(
  response => {
    if (
      !response.config.url.includes("cost/actions/transferir/status/") &&
      !response.config.url.includes("cost/report/") &&
      !response.config.url.includes("cost/estado-transferencia-puntos/") &&
      !response.config.inBackground && pendingCalls > 0
    ) {
      pendingCalls--;
      if (pendingCalls === 0) {
        showMessage("ajax-end", null);
      }
    }
    const notification = JSON.parse(
      response.headers["x-etgs-notification"] || null
    );
    notification ? showMessage("etgs-notification", notification) : showMessage("etgs-notification", null);

    if (response.status === 409) {
      //error de negocio conocido -> tiene que ser manejado en el servicio que hizo la llamada
      return Promise.reject(response);
    } else return response.data;
  },
  error => {
    if (
      !error.config.url.includes("cost/actions/transferir/status/") &&
      !error.config.url.includes("cost/report/") &&
      !error.config.inBackground
    ) {
      pendingCalls--;
      if (pendingCalls === 0) {
        showMessage("ajax-end", null);
      }
    }
    // OMITIR MENSAJES DE ERROR PARA CIERTAS RUTAS
    const omitErrorMessage =
      error.response &&
      (
        (error.response.status === 422 && 
          (error.config.url.includes("/etgs/api/medi/cierres/volumenes-aceptados/grabar") ||
          error.config.url.includes("/etgs/api/medi/cierres/volumenes-aceptados/abrir-cierre"))
        ) ||
        // Omitir TODOS los errores para la ruta de eliminar reportes y validar items
        error.config.url.includes("medi/reportes/reportes-configurables/configuracion-reportes/eliminar") ||
        error.config.url.includes("medi/reportes/reportes-configurables/configuracion-reportes/items/validar")
      );
  

    if (!omitErrorMessage && !error.response.config.skipErrorHandling) {
      if (error.response) {
        if (error.response.status === 401) {
          goTo("/login");
        } else if (error.response.status === 500) {
          if (!error.config.url.includes("/etgs/api/spac/sari/relaciones/")) {
            showMessage("error-resp", error.response.status + " - " + error.response.statusText);
          }
        } else {
          if (!error.config.url.includes("/etgs/api/spac/sari/relaciones/")) {
            showMessage("error-resp", error.response.status + " - " + error.response.statusText);
          }
        }
      } else if (error.request) {
        showMessage("error-req", error.response.status + " - " + error.response.statusText);
      } else {
        showMessage("error", error.message);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;